import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import CRMFollowUpFollowUpH23 from "./crmFollowUpFollowUpH23";

class CrmFollowUpHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandedIndex: [],
    };
  }

  expand = (id) => {
    this.setState((prevValue) => ({
      ...prevValue,
      expandedIndex: [...prevValue.expandedIndex, id],
    }));
  };

  minimize = (id) => {
    const { expandedIndex } = this.state;
    const filteredExpandedIndex = expandedIndex.filter((item) => item !== id);
    this.setState((prevValue) => ({
      ...prevValue,
      expandedIndex: filteredExpandedIndex,
    }));
  };

  render() {
    const { initialValues } = this.props;
    const { expandedIndex } = this.state;
    return (
      <React.Fragment>
        <div>
          {initialValues?.followUpProspect?.map((item) => {
            const label = item?.followUpDate
              ? `${item.followUpDate}, ${item.followUpStatus}`
              : item.followUpStatus;

            return !expandedIndex.includes(item.idFollowUpProspect) ? (
              <FlexView
                style={{ justifyContent: "stretch", marginBottom: "20px" }}
              >
                <FlexView style={{ marginRight: "15px" }}>
                  <SimpleButton
                    onClick={() => this.expand(item.idFollowUpProspect)}
                  >
                    Expand
                  </SimpleButton>
                </FlexView>
                <div className="txt-site txt-main txt-bold">
                  <h1>{label}</h1>
                </div>
              </FlexView>
            ) : (
              <FlexView style={{ marginBottom: "20px" }}>
                <FlexView style={{ marginRight: "15px", paddingTop: "30px" }}>
                  <SimpleButton
                    onClick={() => this.minimize(item.idFollowUpProspect)}
                  >
                    Minimize
                  </SimpleButton>
                </FlexView>
                <CRMFollowUpFollowUpH23
                  data={item}
                  readOnly={true}
                  {...this.props}
                />
              </FlexView>
            );
          })}
        </div>
      </React.Fragment>
    );
  }
}

export default CrmFollowUpHistory;
